
import title from "./title.js"

export default {
    ...title
}